import apiClient from './axios-instance';
import {
    SubscriptionResponse,
    CheckoutSessionRequest,
    CheckoutSessionResponse,
    BillingHistoryResponse,
    CancelSubscriptionResponse,
    PublicSubscriptionPlansResponse
} from '../types/subscription.types';

export const subscriptionApi = {
    /**
     * Public plan catalog. Prices come from payment gateway settings.
     */
    getPublicPlans: async (): Promise<PublicSubscriptionPlansResponse> => {
        const response = await apiClient.get<PublicSubscriptionPlansResponse>('/subscriptions/plans');
        return response.data;
    },

    /**
     * Fetch user's current subscription status
     */
    getCurrentSubscription: async (): Promise<SubscriptionResponse> => {
        const response = await apiClient.get<SubscriptionResponse>('/subscriptions/current');
        return response.data;
    },

    /**
     * Pull latest subscription + payment ledger from MyPaymentNow (used on login).
     */
    refreshFromGateway: async (): Promise<SubscriptionResponse> => {
        const response = await apiClient.post<SubscriptionResponse>('/subscriptions/refresh');
        return response.data;
    },

    /**
     * Create a MyPaymentNow hosted payment page session for upgrading/subscribing
     */
    createCheckoutSession: async (data: CheckoutSessionRequest): Promise<CheckoutSessionResponse> => {
        const response = await apiClient.post<CheckoutSessionResponse>('/subscriptions/create-checkout-session', data);
        return response.data;
    },

    /**
     * Fetch user's billing/payment history
     */
    getInvoices: async (): Promise<BillingHistoryResponse> => {
        const response = await apiClient.get<BillingHistoryResponse>('/subscriptions/invoices');
        return response.data;
    },

    /**
     * Cancel an active subscription (at period end)
     */
    cancelSubscription: async (): Promise<CancelSubscriptionResponse> => {
        const response = await apiClient.post<CancelSubscriptionResponse>('/subscriptions/cancel');
        return response.data;
    },

    /**
     * After checkout: poll for webhook, then auto-sync from the payment gateway.
     */
    syncPending: async (): Promise<SubscriptionResponse> => {
        const response = await apiClient.post<SubscriptionResponse>('/subscriptions/sync-pending');
        return response.data;
    }
};
